import { Checkbox, Modal } from "@shopify/polaris";
import { CookieDialogProps } from "../../types/CookieDialogProps";
import { useTranslation } from "react-i18next";
import CookieDialogStyles from "./CookieDialog.module.css";

export const CookieDialog = ({
    active,
    analyticCookiesEnabled,
    dataPrivacyLink,
    dataPrivacyLinkText,
    onClose,
    onAnalyticsCookieToggle
}: CookieDialogProps) => {
    const { t } = useTranslation("common");

    return (
        <Modal
            open={active}
            onClose={onClose}
            title={
                <span
                    className={CookieDialogStyles['title']}
                >
                    {`${t("cookieDialog.title")}`}
                </span>
            }
        >
            <Modal.Section>
                <h2
                    className={CookieDialogStyles['sectionHeader']}
                >
                    {`${t(
                        "cookieDialog.introduction"
                    )}`}
                </h2>
                <p
                    className={CookieDialogStyles['sectionText']}
                >{`${t(
                    "cookieDialog.introductionSection"
                )}`}</p>
                <h2
                    className={CookieDialogStyles['sectionHeader']}
                >{`${t(
                    "cookieDialog.whatAreCookies"
                )}`}</h2>
                <p
                    className={CookieDialogStyles['sectionText']}
                >{`${t(
                    "cookieDialog.whatAreCookiesSection"
                )}`}</p>
                <h2
                    className={CookieDialogStyles['sectionHeader']}
                >{`${t(
                    "cookieDialog.cookieType"
                )}`}</h2>
                <p
                    className={CookieDialogStyles['sectionText']}
                >{`${t(
                    "cookieDialog.cookieTypeSection"
                )}`}</p>
            </Modal.Section>
            <Modal.Section>
                <div
                    className={CookieDialogStyles['toggleContainer']}
                >
                    <h2
                        className={CookieDialogStyles['sectionHeader']}
                    >{`${t(
                        "cookieDialog.essentialCookies"
                    )}`}</h2>
                    <Checkbox
                        label={t("cookieDialog.enabled")}
                        disabled={true}
                        checked={true}
                    />
                </div>

                <p
                    className={CookieDialogStyles['sectionText']}
                >{`${t(
                    "cookieDialog.essentialCookiesSection"
                )}`}</p>
            </Modal.Section>
            <Modal.Section>
                <div
                    className={CookieDialogStyles['toggleContainer']}
                >
                    <h2
                        className={CookieDialogStyles['sectionHeader']}
                    >{`${t(
                        "cookieDialog.analyticCookies"
                    )}`}</h2>
                    <Checkbox
                        label={analyticCookiesEnabled ? t("cookieDialog.enabled") : t("cookieDialog.disabled")}
                        checked={analyticCookiesEnabled}
                        onChange={onAnalyticsCookieToggle}
                    />
                </div>

                <p
                    className={CookieDialogStyles['sectionText']}
                >{`${t(
                    "cookieDialog.analyticCookiesSection"
                )}`}</p>
            </Modal.Section>
            <Modal.Section>
                <p
                    className={CookieDialogStyles['sectionText']}
                >
                    {`${t("cookieDialog.cookiePolicyMoreInfo")}`}
                    <a
                        href="https://www.idwalmarine.com/terms/cookie-policy"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={CookieDialogStyles['link']}
                    >{`${t("cookieDialog.cookiePolicyTitle")}`}</a>
                    .
                </p>
            </Modal.Section>
            <Modal.Section>
                <h2
                    className={CookieDialogStyles['sectionHeader']}
                >{`${t(
                    "cookieDialog.whatData"
                )}`}</h2>

                <p
                    className={CookieDialogStyles['sectionText']}
                >{`${t(
                    "cookieDialog.theDataCollected"
                )}`}</p>
                <p
                    className={CookieDialogStyles['sectionText']}
                >
                    {`${t("cookieDialog.ipAddress")}`}
                    <br></br>
                    {`${t("cookieDialog.deviceType")}`}
                    <br></br>
                    {`${t("cookieDialog.dateAndTime")}`}
                    <br></br>
                    {`${t("cookieDialog.pagesYouVisit")}`}
                    <br></br>
                    {`${t("cookieDialog.loginDetails")}`}
                    <br></br>
                    {`${t("cookieDialog.browsingBehaviour")}`}
                    <br></br>
                </p>
                <h2
                    className={CookieDialogStyles['sectionHeader']}
                >{`${t(
                    "cookieDialog.cookieConsent"
                )}`}</h2>
                <p
                    className={CookieDialogStyles['sectionText']}
                >{`${t(
                    "cookieDialog.cookieConsentSection"
                )}`}</p>

                <h2
                    className={CookieDialogStyles['sectionHeader']}
                >{`${t(
                    "cookieDialog.dataPrivacy"
                )}`}</h2>
                <p
                    className={CookieDialogStyles['sectionText']}
                >{`${t(
                    "cookieDialog.dataPrivacySection"
                )}`}</p>

                <h2
                    className={CookieDialogStyles['sectionHeader']}
                >{`${t(
                    "cookieDialog.internationalDataTransfers"
                )}`}</h2>
                <p
                    className={CookieDialogStyles['sectionText']}
                >{`${t(
                    "cookieDialog.internationalDataTransfersSection"
                )}`}</p>

                <h2
                    className={CookieDialogStyles['sectionHeader']}
                >{`${t(
                    "cookieDialog.contactUs"
                )}`}</h2>
                <p
                    className={CookieDialogStyles['sectionText']}
                >
                    {`${t("cookieDialog.contactUsSection")}`}{" "}
                    <a
                        className="cookieDialog__link"
                        href={dataPrivacyLink}
                    >
                        {dataPrivacyLinkText}
                    </a>
                </p>
            </Modal.Section>
        </Modal>
    );
};
